import { render, staticRenderFns } from "./cityChg.vue?vue&type=template&id=b0244336&scoped=true&"
import script from "./cityChg.vue?vue&type=script&lang=js&"
export * from "./cityChg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0244336",
  null
  
)

export default component.exports